export const AdGroupNegativeReferenceId = -111;

const getTargetCriterion = ({
  targets,
  type,
  propKey,
  adGroupViewModel,
  campaignViewModel,
  overrideType = undefined,
}) => targets.map((target) => {
  const criterion = {
    Type: overrideType || type,
    BidAdjustment: target.Criterion.BidAdjustment,
    [`${overrideType || type}Criterion`]: {
      [propKey]: target.Criterion.Target,
    },
  };
  if (adGroupViewModel.data.Id) {
    return {
      Id: target.Id,
      Status: target.status ? target.status : 'Active',
      Criterion: criterion,
      CriterionType: type,
      AdGroup: {
        Id: adGroupViewModel.data.Id,
      },
      CampaignName: campaignViewModel.Name,
    };
  }
  return {
    Criterion: criterion,
    CriterionType: type,
    AdGroupName: adGroupViewModel.data.Name,
    CampaignName: campaignViewModel.Name,
    AdGroup: {
      Id: AdGroupNegativeReferenceId,
    },
  };
});

// in this view model to bulk model for targets
// in addition to the criterion, we also add the bid adjustment value for each criterion.
// the structure of this is a an object compared to xandr's array of criterions.
export const viewModelToBulkModelForBidAdjustmentUI = ({ adGroupViewModel, campaignViewModel }) => {
  // ageRanges
  const ageTargets = adGroupViewModel.data.ageRanges || [];
  const negativeAgeRanges = adGroupViewModel.data.negativeAgeRanges || [];
  const genderTypes = adGroupViewModel.data.genderTypes || [];
  const negativeGenderTypes = adGroupViewModel.data.negativeGenderTypes || [];
  const jobTargets = adGroupViewModel.data.jobTargets || [];
  const negativeJobTargets = adGroupViewModel.data.negativeJobTargets || [];
  const industryTargets = adGroupViewModel.data.industry || [];
  const negativeIndustryTargets = adGroupViewModel.data.negativeIndustry || [];
  const companyNameTargets = adGroupViewModel.data.companyNameTargets || [];
  const negativeCompanyNameTargets = adGroupViewModel.data.negativeCompanyNameTargets || [];


  const ageTargetCriterions = getTargetCriterion({
    targets: ageTargets,
    type: 'Age',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const negativeAgeTargetCriterions = getTargetCriterion({
    targets: negativeAgeRanges,
    type: 'NegativeAge',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const genderTargetCriterions = getTargetCriterion({
    targets: genderTypes,
    type: 'Gender',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const negativeGenderTargetCriterions = getTargetCriterion({
    targets: negativeGenderTypes,
    type: 'NegativeGender',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const jobTargetCriterions = getTargetCriterion({
    targets: jobTargets,
    type: 'JobFunction',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const negativeJobTargetCriterions = getTargetCriterion({
    targets: negativeJobTargets,
    type: 'NegativeJobFunction',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const industryTargetCriterions = getTargetCriterion({
    targets: industryTargets,
    type: 'Industry',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const negativeIndustryTargetCriterions = getTargetCriterion({
    targets: negativeIndustryTargets,
    type: 'NegativeIndustry',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const companyNameTargetCriterions = getTargetCriterion({
    targets: companyNameTargets,
    type: 'CompanyName',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  const negativeCompanyNameTargetCriterions = getTargetCriterion({
    targets: negativeCompanyNameTargets,
    type: 'NegativeCompanyName',
    propKey: 'Target',
    adGroupViewModel,
    campaignViewModel,
  });

  return [
    ...ageTargetCriterions,
    ...negativeAgeTargetCriterions,
    ...genderTargetCriterions,
    ...negativeGenderTargetCriterions,
    ...jobTargetCriterions,
    ...negativeJobTargetCriterions,
    ...industryTargetCriterions,
    ...negativeIndustryTargetCriterions,
    ...companyNameTargetCriterions,
    ...negativeCompanyNameTargetCriterions,
  ];
};
